import React from "react";
import { lazyWithRetry } from "utils/lazy-with-retry";

const LazyTasks = lazyWithRetry(() => import("./Tasks"));

const Tasks = (
  props: JSX.IntrinsicAttributes & { children?: React.ReactNode },
) => <LazyTasks {...props} />;

export default Tasks;
